import React from 'react';
import { ArrowLeft, LogOut } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../api/api';
import { API_ENDPOINTS } from '../config/api';
import { useAuth } from '../context/AuthContext';
import './css/header.css';

type HeaderProps = {
  showActions?: boolean;
};

export default function Header({ showActions = true }: HeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const isReportPage = location.pathname.startsWith('/report/financial') || location.pathname.startsWith('/report/leave') || location.pathname.startsWith('/report/tax-reconciliation');

  const handleLogout = async () => {
    try {
      await api.post(API_ENDPOINTS.logout);
    } catch {
      // ignore
    }

    logout();
    navigate('/');
  };

  return (
    <header className="container">
      <div className="header-content">
        <div className="header-left">
          <div className="header-icon">
            <img src="/PayItSmart.png" alt="Pay It Smart logo" className="header-icon-img" />
          </div>
          <h1>PayItSmart</h1>
          {isReportPage && (
            <button type="button" className="header-back-btn" onClick={() => navigate('/report')}>
              <ArrowLeft size={16} />
              Back to Menu
            </button>
          )}
        </div>
        {showActions ? (
          <div className="header-right">
            <button className="profile-btn">
              <div className="profile-avatar">A</div>
            </button>
            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={16} />
              Logout
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
}
